export const logo = 
`  _____          _               _____       _ _                     _ 
 / ____|        | |             |  __ \\     (_) |                   | |
| |     ___   __| | ___ _ __ ___| |__) |__ _ _| |_ __ ___   __ _  __| |
| |    / _ \\ / _  |/ _ \\ '__/ __|  _  // _. | | | '__/ _ \\ / _  |/ _  |
| |___| (_) | (_| |  __/ |  \\__ \\ | \\ \\ (_| | | | | | (_) | (_| | (_| |
 \\_____\\___/ \\__,_|\\___|_|  |___/_|  \\_\\__,_|_|_|_|  \\___/ \\__,_|\\__,_|`


export const locomotive = (year) => `
      .o      
     . ______ 
   _][_||__|| 
  (  HF ${year}| 
 /-OO----OO""=
##############
`

export const end =
`




P
###
`


export const carts = [
  `
           
__.oO.oOo.oOo.oOo.oOo.__ 
|                      | 
|                      | 
"OO------------------OO"=
#########################
`,`
                      
_________________________ 
|                       | 
|                       | 
"OO-------------------OO"=
##########################
`,`
  _______________________
 |                       |  
 |                       |  
_|                       |_ 
"OO---------------------OO"=
############################
`,`
       ___________
 _____||_________||_____
|                       |
|_                     _|
"OO-------------------OO"=
##########################
`,`


.                       .
|                       |
"OO-------------------OO"=
##########################
`,`

_-_-_-_-_-_-_-_-_-_-_-_-_
|                       |
|                       |
"OO-------------------OO"=
##########################
`,`

__________________________
\\                        /
 |                      |
"OO--------------------OO"=
###########################
`
]
